<template>
  <span 
    v-if="isCategory" 
    class="label category mr-1" 
    :style="styleObject" 
    data-testid="category-badge"
  >
    {{ name }}
  </span>
  <span 
    v-else 
    class="tag mr-1" 
    data-testid="tag-badge"
  >
    #{{ name }}
  </span>  
</template>

<script>
import { computed } from "vue";
export default {
  name: "CategoryTagBadge",
  props: {
    name:{
      type: String,
      required: true
    },
    color:{
      type: String,
      default: "#444444"
    },
    isCategory:{
      type: Boolean,
    }
  },

  setup(props){
    const styleObject = computed(() => {
      const color = props.color.replace(/^#/, "");
      const r = parseInt(color.slice(0, 2), 16);
      const g = parseInt(color.slice(2, 4), 16);
      const b = parseInt(color.slice(4, 6), 16);

      const luminance = Math.sqrt(
        0.241 * r ** 2 +
        0.691 * g ** 2 +
        0.068 * b ** 2
      );

      return {
        color: luminance > 170 ? "#444444" : "#ffffff",
        backgroundColor: props.color,
      };
    });

    return { styleObject };
  }
};
</script>

<style lang="scss" scoped>
.category,
.tag{
  margin-top: 4px;
  margin-bottom: 4px;
}
</style>
